import {getCurrentInstance, onUnmounted} from "vue";

import eventBus, {type AppEvents} from "@/app/events/eventBus";

/**
 * Único jeito permitido de um componente/composable ouvir o event bus: a inscrição fica
 * amarrada ao ciclo de vida e é cancelada sozinha no `onUnmounted`. Sem isso, cada
 * montagem acumula handlers e uma tela visitada 3x dispara 3 listagens ao gravar.
 */
export function useEventBus() {
    const inscricoes: Array<() => void> = [];

    function on<K extends keyof AppEvents>(evento: K, handler: (payload: AppEvents[K]) => void) {
        eventBus.on(evento, handler);
        inscricoes.push(() => eventBus.off(evento, handler));
    }

    // Fora de um componente (ex.: helper puro) não há ciclo de vida para amarrar —
    // nesse caso só o `emit` é utilizável.
    if (getCurrentInstance()) {
        onUnmounted(() => {
            inscricoes.forEach((cancelarInscricao) => cancelarInscricao());
        });
    }

    return {on, emit: eventBus.emit};
}
